import { Component, OnInit } from '@angular/core';
import {AdminService} from "../services/admin.service";
import {NotificationsService} from "angular2-notifications";
import {UserService} from "../services/user.service";

@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.css']
})
export class CmsComponent implements OnInit {

  constructor(private adminService:AdminService,
              private  notifSer: NotificationsService,
              private userService:UserService) { }
  hidecmsbutton = true;
  cmsListstatus = true;
  cmsform = false;
  cmsList:Array<any>;
  cmsListlength:any;
  dataobj={
    title:'',
    content:'',
    _csrf:'',
    search:''
  }
  deleteobj = {
    _id:'',
    _csrf:'',
  }
  cms = {
    _id:'',
    title:'',
    content:'',
    _csrf:'',
    status:'',
    checkedcms:[]
  };
  actionListPerformed: Boolean;
  actionViewPerformed: Boolean;
  permission: string;
  checkedCms:Array<any>=[];
  ngOnInit() {
    this.csrf();
    this.adminService.groupupdate.subscribe(permData => {
      localStorage.setItem('permission', permData.permission);
      this.permission = permData.permission
  });
  this.permission = this.adminService.getPermission();

  }
  csrf(){
    this.userService.csrf().subscribe((success) => {
      this.dataobj._csrf = success._csrf;
      this.deleteobj._csrf = success._csrf;
      this.cms._csrf = success._csrf;
    this.getallcmsList();
  }, (error) => {
      this.notifSer.error(
          'Error',
          error.error.message,
          {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
          }
      )
  })
  }
  /**
   * enable  the form
   */
  showCMSForm(){
    this.cmsform = true
    this.cmsListstatus = false;
    this.hidecmsbutton = false;
  }
  /**
   * disable the form
   */
  hideCMSForm(){
    this.cmsListstatus = true;
    this.cmsform = false;
    this.hidecmsbutton=true;
  }
  /**
   *
   * @param val for search list
   */
  search(event){
    this.dataobj.search = event.target.value;
    this.getallcmsList();
  }
  /**
   * list all content management system
   */
  getallcmsList(){
    this.adminService.getCMS(this.dataobj).subscribe((data)=>{
      this.actionListPerformed = true;
      this.actionViewPerformed = false;
      this.cmsList=data.result;
      this.cmsListlength = this.cmsList.length;
    },(err)=>{
      this.notifSer.error(
        'Error',
        err.error.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    })
  }
  /**
   * deleted over all cms
   */
  deleteAllCms(){
    this.adminService.deleteAllCMS({_csrf:this.dataobj._csrf}).subscribe((responce)=>{
      this.notifSer.success(
        'Success',
        responce.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    this.getallcmsList();
    },(err)=>{
      this.notifSer.error(
        'Error',
        err.error.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    })
  }
  /**
   * save content
   */
  saveCMS(){
    this.dataobj.title = this.dataobj.title.trim();
    this.dataobj.content = this.dataobj.content.trim();
    
    if(this.dataobj.title !== '' && this.dataobj.content !== ''){
        this.adminService.addCMS(this.dataobj).subscribe((responce)=>{
          if(responce){
            this.notifSer.success(
              'Success',
              responce.message,
              {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
              )
              this.getallcmsList();
            }
          },(err)=>{
            this.notifSer.error(
              'Error',
              err.error.message,
              {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
              )
            });
          } else {
            this.notifSer.error(
              'Error',
              'Empty White Space Not Allowed to Save',
              {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
              )
        }
  }
  resetForm(){
    this.dataobj.title='';
    this.dataobj.content='';
    this.cms.title = '';
    this.cms.content = '';
  }
  deleteCMS(cms){
  console.log(cms.id);
  this.deleteobj._id = cms._id;
  if(cms.integrated=='Yes'){
    if (window.confirm('Are you sure want to delete this customer. Customer will loose data & money ?')) {
      this.adminService.deleteCMS(this.deleteobj).subscribe((response)=>{
        this.notifSer.success(
          'Success',
          response.message,
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
          }
          )
          this.getallcmsList();
        },(err)=>{
          this.notifSer.error(
            'Error',
            err.error.message,
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
            )
          })
        }
      }else {
        this.adminService.deleteCMS(this.deleteobj).subscribe((response)=>{
          this.notifSer.success(
            'Success',
            response.message,
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
            )
            this.getallcmsList();
          },(err)=>{
            this.notifSer.error(
              'Error',
              err.error.message,
              {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
              )
            })
      }
  }
  View(val){
    console.log(val);
    this.cms._id= val._id;
    this.cms.title = val.title
    this.cms.content = val.content
    this.actionListPerformed = false;
    this.actionViewPerformed = true;
  }
  goback(){
    this.actionListPerformed = true;
    this.actionViewPerformed = false;
  }
  updateCMS(){
    this.cms.title = this.cms.title.trim();
    this.cms.content = this.cms.content.trim();
    
    if((this.cms.title!=='') && (this.cms.content!=='')){
      this.userService.updateCMS(this.cms).subscribe((response)=>{
        this.notifSer.success(
          'Success',
          response.message,
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
          }
          )
          this.getallcmsList();
        },(err)=>{
          this.notifSer.error(
            'Error',
            err.error.message,
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
            )
          })
        } else {
          this.notifSer.error(
            'Error',
            'Empty White Space Not Allowed to Update',
            {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
            )
        }
    
  }
  CmsStatus(_id,status){
    console.log(_id,status);
    this.cms._id = _id;
    this.cms.status=status;
    this.userService.updateCMSStatus(this.cms).subscribe((Response)=>{
      this.getallcmsList();
      this.notifSer.success(
        'Success',
        Response.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    },(err)=>{
      this.notifSer.error(
        'Error',
        err.error.message,
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
      
    })
    
  }
  checkcms(event,cms){
    
    if(event.target.checked){
      this.checkedCms.push(cms)
    }else{
      var index = this.checkedCms.indexOf(cms)
      this.checkedCms.splice(index, 1);
    }
    this.cms.checkedcms = this.checkedCms;
  }
  deleteCheckedCMS(){
    if(this.cms.checkedcms.length !==0){
      this.adminService.deleteCheckedCMS(this.cms).subscribe((respons)=>{
        this.getallcmsList();
        this.notifSer.success(
          'Success',
          respons.message,
          {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
          }
      )
      },(err)=>{
        this.notifSer.error(
          'Error',
          err.error.message,
          {
              timeOut: 3000,
              showProgressBar: true,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
          }
      )
      })
    } else {
      this.notifSer.error(
        'Error',
        'Please Select Any of these',
        {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50
        }
    )
    }
  }
  // isEmptyOrSpaces(str){
  //     // return str === null || str.match(/^ *$/) !== null;
  //     return !/[0-9a-zA-Z-]/.test(str)
  // }
}



// WEBPACK FOOTER //
// ./src/app/cms/cms.component.ts